module.exports = __webpack_public_path__ + "static/coach-hire-services-contract-work-dca637b580c4cc5da7c80a1cd00ab99d.jpg";